const BeneficiaryType = Object.freeze({
  INDIVIDUAL: "INDIVIDUAL",
  COMPANY: "COMPANY",
  TRUST: "TRUST",
});

export default BeneficiaryType;
